<template>
	<div v-if="isUpdateSmart" :class="isUpdateSmart ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			@click="closeAddSmartModal"
		></div>
		<AddSmartGoal
			:goal="dataForSmart"
			:skills="skills"
			:assistance_levels="assistance_levels"
			@updated="updatedSmart"
			@close="closeAddSmartModal"
		/>
	</div>
	<div class="shadow-sm sm:rounded-2xl my-6 overflow-hidden w-full">
		<div class="__record__table w-full overflow-x-auto scroll-bar md-down:overflow-x-hidden">
			<table
				class="w-full divide-y text-neutral-200 rounded-2xl overflow-hidden md-down:table-fixed"
			>
				<thead class="bg-neutral-100 h-16 rounded-2xl">
					<tr>
						<th
							class="px-6 py-3 w-16 md-down:px-2 md-down:w-10"
							v-if="!groupCreate && !isEdit"
						>
							<Checkbox
								:disabled="
									foldersSelected?.length > 0 && !forceChecked
								"
								:value="
									forceChecked ||
									(goals.length > 0 &&
										goals
											.map((f) => f.id)
											?.every((i) =>
												goalsSelected?.includes(i)
											))
								"
								@click="
									!foldersSelected?.length &&
										checkChanged(
											goals,
											!goals
												.map((f) => f.id)
												?.every((i) =>
													goalsSelected?.includes(i)
												)
										)
								"
							/>
						</th>
						<th
							scope="col"
							class="px-6 py-3 text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap text-left w-20 md-down:px-2 md-down:w-10"
						>
							STT
						</th>
						<th
							scope="col"
							class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap min-w-[12rem] md-down:w-full md-down:whitespace-normal md-down:px-2 md-down:min-w-0"
							@click="sorting('goal_name_asc', 'goal_name_desc')"
						>
							<div
								class="flex items-center gap-1 justify-between cursor-pointer"
							>
								{{
									$slots.actions ? 'Nội dung' : 'tên mục tiêu'
								}}
								<svg
									v-if="!$slots.actions"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
										fill="#94A3B8"
									/>
								</svg>
							</div>
						</th>
						<th
							scope="col"
							class="px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-40 md-down:whitespace-normal md-down:px-2 md-down:w-24"
							@click="
								sorting('skill_name_asc', 'skill_name_desc')
							"
						>
							<div
								class="flex items-center gap-1 justify-between cursor-pointer"
							>
								lĩnh vực
								<svg
									v-if="!$slots.actions"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M7.99999 2.39999C8.21216 2.39999 8.41564 2.48428 8.56567 2.63431L10.9657 5.03431C11.2781 5.34673 11.2781 5.85326 10.9657 6.16568C10.6533 6.4781 10.1467 6.4781 9.8343 6.16568L7.99999 4.33136L6.16567 6.16568C5.85325 6.4781 5.34672 6.4781 5.0343 6.16568C4.72188 5.85326 4.72188 5.34673 5.0343 5.03431L7.4343 2.63431C7.58433 2.48428 7.78782 2.39999 7.99999 2.39999ZM5.0343 9.83431C5.34672 9.52189 5.85325 9.52189 6.16567 9.83431L7.99999 11.6686L9.8343 9.83431C10.1467 9.52189 10.6533 9.52189 10.9657 9.83431C11.2781 10.1467 11.2781 10.6533 10.9657 10.9657L8.56567 13.3657C8.25325 13.6781 7.74672 13.6781 7.4343 13.3657L5.0343 10.9657C4.72188 10.6533 4.72188 10.1467 5.0343 9.83431Z"
										fill="#94A3B8"
									/>
								</svg>
							</div>
						</th>
						<th
							v-if="isEdit || $slots.actions"
							class="md-down:w-16"
							:class="{ 'md-down:hidden': hideCreateActionColumn }"
						></th>
					</tr>
				</thead>
				<tbody>
					<template v-for="(goal, index) in goals" :key="goal.id">
						<tr
							class="bg-white text-neutral-700"
							:class="
								$route.query?.goal_id &&
								+goal.id === +$route.query?.goal_id
									? 'bg-yellow-50'
									: index % 2 === 0
									? 'bg-white'
									: 'bg-neutral-50'
							"
						>
							<td
								v-if="!groupCreate && !isEdit"
								class="px-6 py-4 whitespace-nowrap text-neutral-700 md-down:px-2"
							>
								<Checkbox
									:disabled="
										foldersSelected?.length > 0 &&
										!forceChecked
									"
									:value="isGoalChecked(goal)"
									@click="
										!foldersSelected?.length &&
											checkChanged([goal])
									"
								/>
							</td>
							<td
								class="px-6 py-4 whitespace-nowrap text-neutral-700 align-middle w-max md-down:px-2"
							>
								<div class="flex items-center gap-4 md-down:gap-1">
									<div
										v-if="goal.sub_item_count > 0"
										class="w-4 cursor-pointer"
										@click.stop="openSubGoal(goal)"
									>
										<img
											class="w-full"
											v-if="goal.open"
											src="@/assets/images/icons/arrow-up.png"
											alt=""
										/>
										<img
											class="w-full"
											v-else
											src="@/assets/images/icons/arrow-down.png"
											alt=""
										/>
									</div>
									<div>
										{{ index + 1 }}
									</div>
								</div>
							</td>
							<td class="px-6 py-4 text-neutral-700 md-down:px-2">
								<div
									class="w-full flex items-center gap-4"
									v-if="!isEdit"
								>
									<span
										class="break-words"
										v-html="goal.name"
									>
									</span>
									<TooltipGoalDetail
										v-if="
											!goal.sub_item_count &&
											(goal.reason ||
												goal.strategy ||
												goal.process)
										"
										class="shrink-0"
										:tooltip-data="{
											reason: goal.reason,
											strategy: goal.strategy,
											process: goal.process,
											activities: goal.activities,
										}"
									/>
								</div>
								<div
									v-else
									class="input-group flex items-center w-full"
								>
									<textarea
										placeholder="Điền tên mục tiêu mới"
										:value="editName(goal)"
										@input="editNames[goal.id] = $event.target.value"
										@blur="saveGoalName(goal)"
									/>
								</div>
								<div
									v-if="
										!isEdit &&
										(goal.used ||
											goalTaught.includes(goal.id))
									"
									class="flex gap-2 mt-1"
								>
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M8.96966 4.96967C9.26256 4.67678 9.73743 4.67678 10.0303 4.96967C10.3196 5.25897 10.3232 5.72582 10.041 6.01947L6.04876 11.0097C6.043 11.0169 6.03685 11.0238 6.03032 11.0303C5.73743 11.3232 5.26256 11.3232 4.96966 11.0303L2.32322 8.38388C2.03032 8.09099 2.03032 7.61612 2.32322 7.32322C2.61611 7.03033 3.09098 7.03033 3.38388 7.32322L5.4774 9.41674L8.94977 4.9921C8.95595 4.98424 8.96259 4.97674 8.96966 4.96967Z"
											fill="#2AA797"
										/>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M8.04924 10.1099L8.96966 11.0303C9.26256 11.3232 9.73743 11.3232 10.0303 11.0303C10.0368 11.0238 10.043 11.0169 10.0488 11.0097L14.041 6.01947C14.3232 5.72582 14.3196 5.25897 14.0303 4.96967C13.7374 4.67678 13.2626 4.67678 12.9697 4.96967C12.9626 4.97674 12.9559 4.98424 12.9498 4.9921L9.4774 9.41674L8.99205 8.9314L8.04924 10.1099Z"
											fill="#2AA797"
										/>
									</svg>
									<span
										v-if="goal.used_at"
										class="font-semibold text-green-500 text-xs"
										>{{
											$filters.formatDate(goal.used_at)
										}}</span
									>
									<span
										v-else-if="goalTaught.includes(goal.id)"
										class="font-semibold text-green-500 text-xs"
										>{{ dateFormat }}</span
									>
								</div>
								<div
									v-if="!isEdit && goal?.sub_item_count > 0"
									class="text-neutral-400 text-xs font-semibold"
								>
									{{ goal?.sub_item_count }}
									MỤC TIÊU
								</div>
								<div
									class="mt-1 py-0.5 px-2.5 rounded-full bg-yellow-tag text-neutral-700 h-fit w-fit font-semibold shadow-input whitespace-nowrap"
									style="font-size: 10px"
									v-if="goal?.age && !goal?.sub_item_count"
								>
									{{ goal?.age }}
								</div>
							</td>
							<td
								class="px-6 py-4 text-neutral-700 whitespace-nowrap md-down:whitespace-normal md-down:break-words md-down:px-2"
							>
								<div v-if="!isEdit">
									{{ goal.skill?.name }}
								</div>
								<div v-else>
									<Multiselect
										deselect-label="Đã chọn"
										track-by="name"
										:options="
											skills?.map((s) => {
												return {
													nameSearch: toEnglish(
														s?.name
													),
													...s,
												};
											})
										"
										:model-value="
											skills.find(
												(s) => s.id === goal.skill_id
											)
										"
										:searchable="true"
										label="nameSearch"
										:allow-empty="false"
										selectLabel=""
										placeholder="Chọn lĩnh vực"
										@select="
											(value) => {
												goal.skill_id = value?.id;
												updateGoal({
													id: goal.id,
													data: {
														name: goal.name,
														skill_id: value?.id,
													},
												});
											}
										"
									>
										<template #noResult>
											Không tìm thấy kết quả
										</template>
										<template v-slot:option="props">
											<div
												class="flex flex-nowrap items-center"
											>
												<div>
													{{ props.option.name }}
												</div>
											</div>
										</template>
										<template
											v-slot:singleLabel="{ option }"
										>
											<div
												class="flex flex-nowrap items-center font-medium"
											>
												<div>
													{{ option.name }}
												</div>
											</div>
										</template>
									</Multiselect>
								</div>
							</td>
							<td
								class="w-12 md-down:w-16"
								:class="{
									'md-down:hidden': goal?.sub_item_count > 0,
								}"
								v-if="isInCreateGoal"
							>
								<div
									v-if="goal.has_completed_goal"
									class="flex items-center gap-2 whitespace-nowrap"
								>
									<img
										src="@/assets/images/icons/green-tick.png"
										alt=""
										class="w-4 h-4"
									/>
									<div
										class="font-semibold text-green-500 text-xs"
									>
										HOÀN THÀNH
									</div>
								</div>
								<div
									v-else-if="
										(goalTaught.includes(goal.id) ||
											goal.used) &&
										formCreate
									"
									class="font-semibold text-green-500 text-xs"
								>
									Đã thêm
								</div>
								<div
									@click="$emit('action-clicked', goal)"
									v-else-if="!goal?.sub_item_count"
									:data-tour-id="
										index === 0 && isBankAddMtTour
											? 'bank-add-mt'
											: undefined
									"
									class="cursor-pointer text-yellow-600 hover:text-yellow-700 font-semibold text-sm flex items-center pr-2 whitespace-nowrap md-down:whitespace-normal md-down:break-words"
								>
									Thêm MT
								</div>
								<slot name="actions"></slot>
							</td>
							<td class="w-24" v-else-if="isEdit">
								<div class="flex items-center gap-6">
									<div
										@click="
											deleteGoal({
												itemId: goal.id,
												isGoal: true,
											})
										"
										class="text-yellow-600 cursor-pointer hover:text-yellow-700"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M3.125 1.25024C2.43464 1.25024 1.875 1.80989 1.875 2.50024V3.75024C1.875 4.4406 2.43464 5.00024 3.125 5.00024H3.75V16.2502C3.75 17.631 4.86929 18.7502 6.25 18.7502H13.75C15.1307 18.7502 16.25 17.631 16.25 16.2502V5.00024H16.875C17.5654 5.00024 18.125 4.4406 18.125 3.75024V2.50024C18.125 1.80989 17.5654 1.25024 16.875 1.25024H12.5C12.5 0.559888 11.9404 0.000244141 11.25 0.000244141H8.75C8.05964 0.000244141 7.5 0.559888 7.5 1.25024H3.125ZM6.875 6.25024C7.22018 6.25024 7.5 6.53007 7.5 6.87524V15.6252C7.5 15.9704 7.22018 16.2502 6.875 16.2502C6.52982 16.2502 6.25 15.9704 6.25 15.6252L6.25 6.87524C6.25 6.53007 6.52982 6.25024 6.875 6.25024ZM10 6.25024C10.3452 6.25024 10.625 6.53007 10.625 6.87524V15.6252C10.625 15.9704 10.3452 16.2502 10 16.2502C9.65482 16.2502 9.375 15.9704 9.375 15.6252V6.87524C9.375 6.53007 9.65482 6.25024 10 6.25024ZM13.75 6.87524C13.75 6.53007 13.4702 6.25024 13.125 6.25024C12.7798 6.25024 12.5 6.53007 12.5 6.87524V15.6252C12.5 15.9704 12.7798 16.2502 13.125 16.2502C13.4702 16.2502 13.75 15.9704 13.75 15.6252V6.87524Z"
												fill="currentColor"
											/>
										</svg>
									</div>
									<div
										@click="openAddSmartModal(goal)"
										class="text-yellow-600 cursor-pointer hover:text-yellow-700"
									>
										<svg
											width="20"
											height="20"
											viewBox="0 0 20 20"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M15.4041 8.49733L17.1377 6.76375L17.1377 6.76374L17.1377 6.76372C17.6368 6.26463 17.8863 6.01508 18.0269 5.74991C18.3376 5.164 18.3376 4.46221 18.0269 3.8763C17.8863 3.61112 17.6368 3.36156 17.1377 2.86246C16.6386 2.36335 16.389 2.11379 16.1238 1.97321C15.5379 1.66258 14.8361 1.66258 14.2502 1.97321C13.985 2.11379 13.7355 2.36335 13.2364 2.86246L11.4807 4.61818C12.4198 6.22874 13.772 7.57058 15.4041 8.49733ZM10.0262 6.07265L3.36419 12.7346C2.93913 13.1597 2.7266 13.3722 2.58687 13.6333C2.44713 13.8944 2.38819 14.1891 2.27029 14.7786L1.67957 17.7322C1.61305 18.0648 1.57979 18.2311 1.6744 18.3257C1.76901 18.4203 1.93531 18.3871 2.26792 18.3206L5.22152 17.7298C5.81098 17.6119 6.1057 17.553 6.3668 17.4133C6.6279 17.2735 6.84043 17.061 7.26549 16.6359L13.9459 9.95556C12.3647 8.96432 11.027 7.63576 10.0262 6.07265Z"
												fill="currentColor"
											/>
										</svg>
									</div>
								</div>
							</td>
						</tr>
						<tr
							class="text-neutral-700"
							:class="
								index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'
							"
							v-if="goal.open && goal?.sub_item_count > 0"
						>
							<td colspan="6" class="pl-16 md-down:pl-4">
								<ChildGoal
									:data="goal"
									:foldersSelected="foldersSelected"
									:forceChecked="forceChecked"
									:isInCreateGoal="isInCreateGoal"
									:groupCreate="groupCreate"
									:isAdmin="isAdmin"
									:formCreate="formCreate"
									:isEdit="isEdit"
									@action-clicked="
										(data) => $emit('action-clicked', data)
									"
									@delete-goal="deleteGoal"
									@open-add-smart-modal="openAddSmartModal"
									@update-goal="updateGoal"
									@create-goal="onCreateGoal"
								/>
							</td>
						</tr>
					</template>
					<tr class="bg-white text-neutral-700" v-if="showCreateRow">
						<td
							class="px-6 py-4 whitespace-nowrap text-neutral-700"
						>
							<div>
								{{ goals.length + 1 }}
							</div>
						</td>
						<td class="px-6 py-4 text-neutral-700">
							<div class="input-group flex items-center w-full">
								<input
									type="text"
									placeholder="Điền tên mục tiêu mới"
									v-model="name"
									:class="error ? 'input--error' : ''"
									@blur="submitCreate"
									@keyup.enter="submitCreate"
								/>
							</div>
						</td>
						<td class="px-6 py-4 text-neutral-700 w-40">
							<Multiselect
								deselect-label="Đã chọn"
								track-by="name"
								:options="
									skills?.map((s) => {
										return {
											nameSearch: toEnglish(s?.name),
											...s,
										};
									})
								"
								v-model="skillSelected"
								:searchable="true"
								label="nameSearch"
								:allow-empty="false"
								selectLabel=""
								placeholder="Chọn lĩnh vực"
								@change="onSkillSelected"
							>
								<template #noResult>
									Không tìm thấy kết quả
								</template>
								<template v-slot:option="props">
									<div class="flex flex-nowrap items-center">
										<div>
											{{ props.option.name }}
										</div>
									</div>
								</template>
								<template v-slot:singleLabel="{ option }">
									<div
										class="flex flex-nowrap items-center font-medium"
									>
										<div>
											{{ option.name }}
										</div>
									</div>
								</template>
							</Multiselect>
						</td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Multiselect from '@suadelabs/vue3-multiselect';
import { $api } from '@/services';
import TooltipGoalDetail from '@/components/elements/tooltipGoalDetail/TooltipGoalDetail';
import { toEnglish } from '@/helper/toEnglish';
import AddSmartGoal from '@/views/goalFolders/features/AddSmartGoal';
import Checkbox from '@/components/elements/checkbox/Checkbox';
import ChildGoal from './ChildGoal.vue';
import dayjs from 'dayjs';
import { useTutorial } from '@/features/tutorial/useTutorial';

export default {
	name: 'GoalItemsTable',

	components: {
		AddSmartGoal,
		TooltipGoalDetail,
		Multiselect,
		Checkbox,
		ChildGoal,
	},

	props: {
		goals: {
			type: Array,
			default: () => [],
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		skills: {
			type: Array,
			required: true,
		},
		isInCreateGoal: {
			type: Boolean,
			default: false,
		},
		groupCreate: {
			type: Boolean,
			default: false,
		},
		formCreate: {
			type: Boolean,
			default: false,
		},
		parentId: {
			type: [String, Number],
			default: null,
		},
		showCreateRow: {
			type: Boolean,
			default: false,
		},
		assistance_levels: {
			type: Array,
			default: () => [],
		},
		forceChecked: {
			type: Boolean,
			default: false,
		},
	},

	emits: [
		'create-goal',
		'delete-goal',
		'updated',
		'action-clicked',
		'fetchNew',
	],

	data() {
		return {
			skillSelected: null,
			name: '',
			error: '',
			sortBy: '',
			isUpdateSmart: false,
			dataForSmart: null,
			editNames: {},
		};
	},

	computed: {
		id() {
			return this.$route?.params?.id || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		goalsSelected() {
			const s = this.$store.getters.goalsSelected;
			return (s || []).map((i) => i.id);
		},

		foldersSelected() {
			const s = this.$store.getters.foldersSelected;
			return (s || []).map((i) => i.id);
		},

		goalTaught() {
			return this.$store.getters.goalTaught;
		},

		dateFormat() {
			return dayjs(Date.now()).format('DD/MM/YYYY');
		},

		isBankAddMtTour() {
			const tutorial = useTutorial();
			return (
				this.isInCreateGoal &&
				tutorial.isAddGoalTour.value
			);
		},

		hideCreateActionColumn() {
			return (
				!this.isEdit &&
				this.goals.length > 0 &&
				this.goals.every((goal) => goal?.sub_item_count > 0)
			);
		},
	},

	watch: {
		isEdit: {
			handler(editing) {
				if (!editing) {
					this.editNames = {};
					return;
				}
				this.syncEditNames();
			},
			immediate: true,
		},
		goals() {
			if (this.isEdit) this.syncEditNames();
		},
	},

	methods: {
		toEnglish,

		brToNewline(value) {
			return String(value || '').replace(/<br\s*\/?>|<\/br>/gi, '\n');
		},

		newlineToBr(value) {
			return String(value || '').replace(/\r?\n/g, '<br />');
		},

		syncEditNames() {
			this.goals.forEach((goal) => {
				if (this.editNames[goal.id] === undefined) {
					this.editNames[goal.id] = this.brToNewline(goal.name);
				}
			});
		},

		editName(goal) {
			if (this.editNames[goal.id] === undefined) {
				return this.brToNewline(goal.name);
			}
			return this.editNames[goal.id];
		},

		saveGoalName(goal) {
			const name = this.newlineToBr(this.editName(goal));
			goal.name = name;
			this.editNames[goal.id] = this.brToNewline(name);
			this.updateGoal({
				id: goal.id,
				data: { name },
			});
		},

		isGoalChecked(goal) {
			if (this.forceChecked) {
				return true;
			}
			if (goal?.sub_item_count > 0) {
				return goal.sub_items
					?.map((f) => f.id)
					?.every((i) => this.goalsSelected?.includes(i));
			}
			return this.goalsSelected?.includes(goal.id);
		},

		sorting(key1, key2) {
			if (this.sortBy === key1) {
				this.sortBy = key2;
			} else {
				this.sortBy = key1;
			}
			this.$router.push({
				query: {
					...this.$route.query,
					sort_by: this.sortBy,
				},
			});
			this.$emit('fetchNew', this.sortBy);
		},

		checkChanged(goals, isAll) {
			this.$store.dispatch('selected', { goals, isAll });
			for (let goal of goals) {
				if (goal.sub_item_count > 0) {
					for (let s of goal.sub_items) {
						this.checkChanged([s]);
					}
				}
			}
		},

		onCreateGoal(data) {
			this.$emit('create-goal', data);
			this.name = '';
		},

		submitCreate() {
			if (!this.name) {
				return;
			}
			this.$emit('create-goal', {
				name: this.name,
				skill: this.skillSelected,
				parent_id: this.parentId,
			});
			this.name = '';
		},

		onSkillSelected() {
			if (!this.name) {
				this.error = 'Tên mục tiêu không được trống';
				setTimeout(() => {
					this.error = '';
				}, 3000);
				return;
			}
			this.submitCreate();
		},

		async updateGoal({ id, data }) {
			try {
				await $api.goal.updateGoalByParent(this.id, id, data);
				this.$store.dispatch('setAlertMessage', {
					message: 'Cập nhật mục tiêu thành công',
				});
				this.$emit('updated');
			} catch (e) {
				await this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		deleteGoal(data) {
			this.$emit('delete-goal', {
				...data,
				root: false,
			});
		},

		openAddSmartModal(data) {
			this.dataForSmart = data;
			this.isUpdateSmart = true;
		},

		closeAddSmartModal() {
			this.dataForSmart = null;
			this.isUpdateSmart = false;
		},

		updatedSmart() {
			this.closeAddSmartModal();
			this.$store.dispatch('setAlertMessage', {
				message: 'Cập nhật mục tiêu SMART thành công',
			});
			this.$emit('updated');
		},

		openSubGoal(goal) {
			if (goal.sub_item_count > 0) goal.open = !goal.open;
		},
	},
};
</script>
